import { CIMSModuleItem } from './CIMSModuleItem'

export const Admin = new CIMSModuleItem({
  id: '3dc18c1b-790c-4820-9b0e-0dd8c445e3a5',
  pathname: 'administration',
  name: 'Administration',
})
export const CAS = new CIMSModuleItem({
  id: '8ea9b0dd-5871-433b-800b-14f340fed302',
  pathname: 'construction-admin-submittals',
  deprecatedPathnames: ['certs', 'certs-and-submittals'],
  name: 'Construction & Admin Submittals',
})
export const Concrete = new CIMSModuleItem({
  id: '6bd4a089-8b84-4f7e-80a1-01e0d9bfe951',
  pathname: 'concrete',
  name: 'Concrete',
})
export const DS = new CIMSModuleItem({
  id: '5e3a63db-90ef-4c5c-ba98-171e15403ca7',
  pathname: 'design-submittals',
  name: 'Design Submittals',
})
export const ImportsExports = new CIMSModuleItem({
  id: 'dec1f846-5b5b-447b-85c9-bf0bb4b8d4ee',
  pathname: 'imports-exports',
  name: 'Imports & Exports',
})
export const FDC = new CIMSModuleItem({
  id: '4c39cfa7-6121-47da-9080-80686898d068',
  pathname: 'field-design-changes',
  name: 'Field Design Changes',
})
export const PayItems = new CIMSModuleItem({
  id: 'b679795f-db6c-4dd1-94c7-11b79c739739',
  pathname: 'pay-items',
  deprecatedPathnames: ['payitems'],
  name: 'Pay Items',
})
export const Home = new CIMSModuleItem({
  id: '7f773038-4179-4a61-928c-78b837853f76',
  name: 'Home',
  pathname: 'home',
})
export const IFI = new CIMSModuleItem({
  id: 'e32c43fc-de32-4155-9be7-15617848d041',
  name: 'Identified Field Issues',
  pathname: 'identified-field-issues',
})
export const Issues = new CIMSModuleItem({
  id: '462cdf23-3f8a-4cb2-8cf5-99cfcdb0f8db',
  name: 'Issues',
  pathname: 'issues',
})
export const RFI = new CIMSModuleItem({
  id: 'ec7475e6-feaf-4f59-87f0-356991258bb2',
  name: 'Requests For Information',
  pathname: 'requests-for-information',
})
export const EJ = new CIMSModuleItem({
  id: '2561CA38-407C-4F75-8EC5-849E90B23DA2',
  name: 'Engineering Judgements',
  pathname: 'judgements',
})
export const Developer = new CIMSModuleItem({
  id: 'd562d76b-ef68-46f2-976c-1e4b4191e27b',
  name: 'Developer',
  pathname: 'developer',
})
export const Materials = new CIMSModuleItem({
  id: 'e2044730-c08c-4937-93c2-84b56db16192',
  name: 'Materials',
  pathname: 'materials',
})
